import { AxiosError } from 'axios';
import { useEffect } from 'react';
import { useMutation } from 'react-query';
import { useHistory, useParams } from 'react-router';
import { routes } from '@/constant/routes.const';
import { verifyEmail, verifyPassport } from '@/api';
import LoadingView from '@/components/common/LoadingView';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import {
  IVerifyEmailPayload,
  IVerifyPassportPayload,
  IVerifyPassportResponse,
} from '@/types/common.type';
import { isNationIncluded } from '@repo/utils';
import { MAIN_NATIONS } from '@repo/constants';

type Props = {
  id: string;
  verifiedEmail: string;
};

function VerifiactionRedirect() {
  const { id, verifiedEmail } = useParams() as Props;
  const passportNumber = id.toUpperCase();
  const dispatch = useAppDispatch();
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const isInquiry = searchParams.get('inquiry') || 'false';

  const passportMutation = useMutation<
    IVerifyPassportResponse,
    AxiosError,
    IVerifyPassportPayload
  >((payload) => verifyPassport(payload), {
    retry: false,
    onSuccess: ({ register, nation, ...rest }) => {
      nation && localStorage.setItem('customerNation', nation);
      dispatch({
        type: 'UPDATE_USER_INFO',
        payload: {
          passportNumber,
          register,
          nationality: nation,
          ...rest,
        },
      });
      localStorage.setItem('login', passportNumber);
      verifyMutation.mutate({ passportNumber, verifiedEmail });
      if (isInquiry === 'true') {
        return history.push(routes.inquiryQna);
      }
      history.push(routes.customerRefund);
    },
  });

  const verifyMutation = useMutation<number, AxiosError, IVerifyEmailPayload>(
    (payload) => verifyEmail(payload),
    {
      retry: false,
      onSuccess: () => {
        dispatch({
          type: 'UPDATE_USER_INFO',
          payload: {
            verifiedEmail,
            email: verifiedEmail,
          },
        });
        console.log('이메일 인증 성공', verifiedEmail);
      },
      onError: () => {
        alert('이메일 인증에 실패하였습니다. 다시 시도해주세요.');
      },
    },
  );

  useEffect(() => {
    passportMutation.mutate({ passportNumber });
  }, []);

  return <LoadingView />;
}

export default VerifiactionRedirect;
